import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GetBaseUrl } from "app/helper/getBaseUrl";
import { ITicket } from "app/interfaces/i-ticket";
import { Observable } from "rxjs";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class ApiIncomingCallService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) { }

    public getCallReverse(token: string): Observable<ITicket> {
        return this.http.get<ITicket>(this.baseUrl + "/ticket-guest/call/reverse/" + token)
    }
}